import { render, staticRenderFns } from "./ProjectAddressDialog.vue?vue&type=template&id=4cbde180&scoped=true&lang=pug&"
import script from "./ProjectAddressDialog.vue?vue&type=script&lang=ts&"
export * from "./ProjectAddressDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbde180",
  null
  
)

export default component.exports